export default {
  setChangeDate (state: {[key:string]: string}, value: string) {
    state.changeDate = value
  },
  setForceChangeDateFlag (state: {[key:string]: boolean}, value: boolean) {
    state.forceChangeDateFlag = value
  }
}
